import React from 'react';

const Footer = () => (
    <div className="fixed-bottom">
        <div className="pt-2 pb-2 header-bg text-white">
                <div className="d-inline-flex align-items-center justify-content-between w-100">
                    <img src="frequentiel.svg" className="ms-5" width='120' alt="My Happy SVG"/>
                    <div className="color-freq-primary me-5">©2025 frequentiel | www.frequentiel.com | Tous droits réservés | Delivery-Express - 1.0.0</div>
                </div>
        </div>
    </div>
);

export default Footer;
